import * as React from 'react'
import Milliseconds from '../../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            wt: number
        }
    }
}

export default class SleepBottleneck extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let time = <span></span>
        if (message) {
            time = (
                <span>
                    (<Milliseconds value={message.args.wt} />)
                </span>
            )
        }

        return (
            <div>
                <p>
                    Significant time {time} was spent in <code>sleep</code> or <code>usleep</code> calls.
                </p>
                <p>
                    If you cannot identify where this happens from the trace, consider
                    <a href="https://support.tideways.com/documentation/features/triggering-profiler/index.html">triggering a call graph</a>
                    that collects every function call and their callers.
                </p>
                <p>
                    If there is also a slow <code>session_start</code> span, the <code>sleep</code> calls could be due to legitimate
                    <a href="https://tideways.com/profiler/blog/detecting-bottlenecks-blocking-session">session blocking logic</a>.
                </p>
                <p>Removing or optimizing these calls can improve performance.</p>
            </div>
        )
    }
}
